<div class="customer-page-group">
  <div class="customer-page-group-wrapper">
    <div class="content-header">
      <div class="header-group">
        <h3 class="customer-page-title">Let's Help You Take the Next Step</h3>
        <p class="customer-page-description">Before you go, would you like a little help finding the right practitioner or booking a session? Leave your details and one of our support team members will be in touch shortly to assist you.</p>
      </div>
      <button class="arrow-btn" (click)="closeModal()"><img src="assets/images/close.svg" alt=""></button>
    </div>
    <form [formGroup]="userForm">

      <div class="field-type-2" [ngClass]="{'invalid': userName?.dirty && userName?.errors}">
        <label for="name" class="field-label">Name <span class="field-mandatory">*</span></label>
        <input type="text" class="field-input" name="user_name" formControlName="name">
        <ul class="errors" *ngIf="userName?.dirty && userName?.errors">
          <li *ngIf="userName?.errors.required">Name is required</li>
          <li *ngIf="userName?.errors.minlength || userName?.errors.pattern">First name is invalid</li>
        </ul>
      </div>

      <div class="field-type-2">
        <label for="preferred_contact_method" class="field-label">Preferred Contact Method<span class="field-mandatory">*</span></label>
        <mat-select class="field-type-select" placeholder="Select preferred contact method" panelClass="custom-field-type-select" formControlName="preferred_contact_method" (selectionChange)="preferredContact($event)">
          <ng-container *ngFor="let item of methods">
            <mat-option [value]="item">
              {{item}}
            </mat-option>
          </ng-container>
        </mat-select>
      </div>

       <div class="field-type-2" *ngIf="isEmailPreferred" [ngClass]="{'invalid': userEmail?.dirty && userEmail?.errors}">
        <label for="name" class="field-label">Email <span class="field-mandatory">*</span></label>
        <input type="text" class="field-input" name="user_name" formControlName="email">
        <ul class="errors" *ngIf="userEmail?.dirty && userEmail?.errors">
          <li *ngIf="userEmail?.errors.required">Email is required</li>
          <li *ngIf="userEmail?.errors.minlength || userEmail?.errors.alphanumeric">Email is invalid</li>
        </ul>
      </div>

      <app-tel-input *ngIf="isPhonePreferred" label="Phone" parentClass="field-type-2" [required]="isPhonePreferred" [showErrorLabel]="true" [value]="phoneObject" (phoneGroupEmit)="phoneGroupEmit($event)"></app-tel-input>

      <div class="field-type-2">
        <label for="best_time_to_reach" class="field-label">Best Time to Reach You<span class="field-mandatory">*</span></label>
        <mat-select class="field-type-select" placeholder="Select best time to reach you" panelClass="custom-field-type-select" (selectionChange)="bestTimeToReach($event)">
          <ng-container *ngFor="let item of timings">
            <mat-option [value]="item">
              {{item}}
            </mat-option>
          </ng-container>
        </mat-select>
      </div>

       <div class="field-type-1">
          <p class="field-label">Additional notes</p>
          <textarea class="field-input" formControlName="appointment_notes" placeholder=""></textarea>
        </div>

      </form>
      <div class="content-footer">
        <button class="discard-button" type="button" (click)="skip()">Skip</button>
        <button class="primary-btn" (click)="submiteDetails()" [disabled]="userForm.invalid">Submit</button>
    </div>
  </div>
</div>
